// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"bdf63cb2","99":"16137834","850":"079e36d0"}[chunkId] + ".css";
};